import { render, staticRenderFns } from "./addstudent.vue?vue&type=template&id=8abe7fc0&scoped=true"
import script from "./addstudent.vue?vue&type=script&lang=js"
export * from "./addstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abe7fc0",
  null
  
)

export default component.exports